import { render, staticRenderFns } from "./WatchList.vue?vue&type=template&id=365164e4&scoped=true"
import script from "./WatchList.vue?vue&type=script&lang=js"
export * from "./WatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365164e4",
  null
  
)

export default component.exports